module.exports = __webpack_public_path__ + "static/media/during_purchase.a557fd33.png";